import React, { useState, useContext } from 'react'

import MyContext from '../components/MyContext'

const MERCHANT_URL = process.env.REACT_APP_MERCHANT_URL

export default () => {
	const [loading, setLoading] = useState(false)
	const [cityList, setCityList] = useState([])
	const { mToken, showSnackbar } = useContext(MyContext)

	const getCityList = async () => {
		setLoading(true)

		const abortController = new AbortController()

		const timeout = setTimeout(() => {
			showSnackbar('Connection timeout, please try again! (5)', 'warning')
			abortController.abort()
			setLoading(false)

			return {status: false}
		}, 20000)

		try {
			const access_token = mToken
			const response = await fetch(`${MERCHANT_URL}/cities`, {
				signal: abortController.signal,
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${access_token}`,
					Accept: 'application/json',
				},
			})

			if (response.status >= 400 && response.status <= 500) {
				showSnackbar('Please contact Marathon for this problem. (5)', 'error')
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			const responseData = await response.json()

			if (responseData.status == 3) {
				showSnackbar('Session expired (5)', 'error')
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			if (responseData.status == 2) {
				showSnackbar('Something went wrong. (5)', 'warning')
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			if (responseData.status == 1) {
				clearTimeout(timeout)
				setLoading(false)

				setCityList(responseData.data)

				return {status: true, payload: responseData.data}
			}
		} catch (e) {
			setLoading(false)
			showSnackbar('Connection problem, please try again. (5)', 'warning')
			clearTimeout(timeout)
			console.log(e)

			return {status: false}
		}
	}

	return {
		loading,
		cityList,
		getCityList,
	}
}
